"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const prompt_1 = require("./prompt");
const source_1 = require("./source");
class BareInput extends React.Component {
    render() {
        if (this.props.hidden) {
            return null;
        }
        return React.createElement("div", { className: this.props.className }, this.props.children);
    }
}
BareInput.defaultProps = {
    children: null,
    hidden: false
};
exports.Input = styled_components_1.default(BareInput) `
  & {
    display: flex;
    flex-direction: row;
  }

  &.invisible {
    height: 34px;
  }

  & ${prompt_1.Prompt} {
    flex: 0 0 auto;
  }

  & ${source_1.Source} {
    flex: 1 1 auto;
    overflow: visible;
    background-color: var(--theme-cell-input-bg, #fafafa);
  }
`;
exports.Input.displayName = "Input";
exports.default = exports.Input;
//# sourceMappingURL=input.js.map